import { render, staticRenderFns } from "./iconCartEmpty.vue?vue&type=template&id=cdc1baf6&scoped=true"
import script from "./iconCartEmpty.vue?vue&type=script&lang=js"
export * from "./iconCartEmpty.vue?vue&type=script&lang=js"
import style0 from "./iconCartEmpty.vue?vue&type=style&index=0&id=cdc1baf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc1baf6",
  null
  
)

export default component.exports